module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('claims-dashboard-icons'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "u-margin-top-20 u-margin-bottom-10"
  }, [_c('filter-options', {
    attrs: {
      "title": "Claim Search",
      "button-title": "Search",
      "action": _vm.search,
      "reset": _vm.reset,
      "running": false,
      "filter": _vm.updateFilter
    }
  })], 1), _vm._v(" "), (_vm.claims.length === 0 && !_vm.loading) ? _c('div', {
    staticClass: "u-d-flex"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "u-d-flex"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.claims.length && !_vm.loading) ? _c('span', {
    staticClass: "c-table-filter u-cursor-pointer",
    on: {
      "click": _vm.showHideFilters
    }
  }, [_vm._v("Filter Table Columns")]) : _vm._e(), _vm._v(" "), (_vm.filters && _vm.claims.length) ? _c('div', [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin-slight a-form-inputs flex-grid--wrap p-your-claims__bordered"
  }, _vm._l((_vm.availableColumns), function(columnData) {
    return _c('div', {
      staticClass: "flex-grid__g-3 p-your-claims__column-filter"
    }, [_c('div', {
      staticClass: "a-checkbox u-margin-top-20 u-margin-bottom-20"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.showColumns),
        expression: "showColumns"
      }],
      attrs: {
        "autocomplete": "off",
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "value": columnData.value,
        "checked": Array.isArray(_vm.showColumns) ? _vm._i(_vm.showColumns, columnData.value) > -1 : (_vm.showColumns)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.showColumns,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = columnData.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.showColumns = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.showColumns = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.showColumns = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "text"
      }
    }, [_vm._v(_vm._s(columnData.name))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-reserving__assign"
  }, [_c('div', {
    class: {
      'a-loader--table': _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('table', {
    staticClass: "a-table a-table--full-width your-claims-table p-your-claims__table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeOrder('your_reference')
      }
    }
  }, [_vm._v("\n                        Your Reference\n                    ")])]), _vm._v(" "), _vm._l((_vm.showColumns), function(columnValue) {
    return _c('th', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeOrder(columnValue)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.columnTitle(columnValue)) + "\n                    ")])])
  }), _vm._v(" "), _c('th', [_vm._v("\n                     \n                ")])], 2)]), _vm._v(" "), _vm._l((_vm.claims), function(claim) {
    return (_vm.claims.length) ? _c('tbody', [_c('tr', [_c('td', [_vm._v("\n                    " + _vm._s(claim.your_reference) + "\n                ")]), _vm._v(" "), _vm._l((_vm.showColumns), function(columnValue) {
      return _c('td', [_vm._v("\n                    " + _vm._s(_vm.output(claim, columnValue)) + "\n                ")])
    }), _vm._v(" "), _c('td', {
      attrs: {
        "width": "80"
      }
    }, [_c('div', {
      staticClass: "u-d-flex u-flex-space-between p-your-claims__table-icons"
    }, [_c('div', {
      staticClass: "u-float-l u-margin-right-20",
      on: {
        "click": function($event) {
          return _vm.toggleSummary(claim.id)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'expand' + claim.id,
        "tooltip-text": "more claim details",
        "side": "top",
        "text-width": "150",
        "icon-type": "toggle"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "u-float-l u-margin-right-20",
      on: {
        "click": function($event) {
          return _vm.sendLoad(claim)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'load' + claim.id,
        "tooltip-text": "load",
        "side": "top",
        "text-width": "100",
        "icon-type": "load"
      }
    })], 1), _vm._v(" "), (_vm.showDelete) ? _c('div', {
      staticClass: "u-float-l",
      on: {
        "click": function($event) {
          return _vm.sendDelete(claim)
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'delete' + claim.id,
        "tooltip-text": "delete",
        "side": "left",
        "text-width": "100",
        "icon-type": "delete"
      }
    })], 1) : _vm._e()])])], 2), _vm._v(" "), _c('tr', {
      staticClass: "p-your-claims--claim-summary",
      class: _vm.showSummary(claim.id) ? 'u-d-table-row u-full-width' : 'u-d-none'
    }, [(_vm.showAllSummary) ? _c('td', {
      staticClass: "u-padding-30",
      attrs: {
        "colspan": _vm.showColumns.length + 2
      }
    }, [_c('h2', {
      staticClass: "summary-heading"
    }, [_vm._v("\n                        Summary of " + _vm._s(claim.your_reference) + "\n                        "), (_vm.showNames) ? _c('span', [_vm._v(": " + _vm._s(claim.claimant_name) + " v " + _vm._s(claim.defendant_name))]) : _vm._e()]), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "flex-grid flex-grid--reduced-bottom-margin u-r-flex-direction-row u-r-flex-wrap"
    }, [_c('div', {
      staticClass: "flex-grid__g-3"
    }, [_c('h2', [_vm._v("\n                                Claim Data\n                            ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Claim Type: "), _c('strong', [_vm._v(_vm._s(claim.human_claim_type))])]), _vm._v(" "), _c('li', [_vm._v("Discount Rate: "), _c('strong', [_vm._v(_vm._s(claim.discount_rate) + "%")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
      staticClass: "u-float-l"
    }, [_vm._v("\n                                Claim Info\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "p-your-claims--edit-icon u-float-l",
      on: {
        "click": function($event) {
          return _vm.updateEditing('showClaimInfo')
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_claim_info' + claim.id,
        "tooltip-text": "edit",
        "side": "right",
        "text-width": "100",
        "icon-type": "edit"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "u-clear"
    }), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Handler: "), _c('strong', [_vm._v(_vm._s(_vm.userFrom(claim)))])]), _vm._v(" "), _c('li', [_vm._v("Team: "), _c('strong', [_vm._v(_vm._s(_vm.teamFrom(claim)))])]), _vm._v(" "), _c('li', [_vm._v("Open Date: "), _c('strong', [_vm._v(_vm._s(_vm.dateFormat(claim.open_date, "DD/MM/YYYY")))])]), _vm._v(" "), _c('li', [_vm._v("Status: "), _c('strong', [_vm._v(_vm._s(claim.active ? 'Open' : 'Closed'))])]), _vm._v(" "), _c('li', [_vm._v("Outcome: "), _c('strong', [_vm._v(_vm._s(claim.outcome ? claim.outcome : '-'))])])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-grid__g-3"
    }, [_c('h2', {
      staticClass: "u-float-l"
    }, [_vm._v("\n                                Reserves & Costs\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "p-your-claims--edit-icon u-float-l",
      on: {
        "click": function($event) {
          return _vm.updateEditing('showReservesCosts')
        }
      }
    }, [_c('icon-tooltip', {
      attrs: {
        "tooltip-name": 'edit_reserves_costs' + claim.id,
        "tooltip-text": "edit",
        "side": "right",
        "text-width": "100",
        "icon-type": "edit"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "u-clear"
    }), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n                                    Damages Reserve: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'current_damages_reserve')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Third Party Costs Reserve: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'current_third_party_reserve')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Defence Costs Reserve: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'current_defence_costs_reserve')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Paid Damages: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'paid_damages')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Paid Third Party Costs: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'paid_third_party_costs')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Paid Defence Costs: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim,
      'paid_defence_costs')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Recovered Costs: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'recovered_costs')))])]), _vm._v(" "), _c('li', [_vm._v("\n                                    Total Reserve: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'total_current_reserve')))])]), _vm._v(" "), _c('li', [_vm._v("Total Paid: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'total_paid')))])]), _vm._v(" "), _c('li', [_vm._v("Net Paid: "), _c('strong', [_vm._v(_vm._s(_vm.formatCost(claim, 'net_paid')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "flex-grid__g-3"
    }, [_c('h2', [_vm._v("\n                                Documents\n                            ")]), _vm._v(" "), _c('ul', [_c('a', {
      attrs: {
        "href": '/api/v1/executive-summary/pdf/' + claim.id + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_vm._m(3, true)]), _vm._v(" "), (claim.recent_schedule_of_loss) ? _c('a', {
      attrs: {
        "href": '/api/v1/generated-documents/pdf/' + claim.recent_schedule_of_loss.id + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('li', [_c('strong', [_vm._v(_vm._s(claim.recent_schedule_of_loss.name))]), _c('br'), _vm._v("\n                                        —\n                                        " + _vm._s(_vm.dateFormat(claim.recent_schedule_of_loss.created_at, "DD/MM/YYYY H:m")) + "\n                                    ")])]) : _vm._e(), _vm._v(" "), (claim.recent_comparison_schedule) ? _c('a', {
      attrs: {
        "href": '/api/v1/generated-documents/pdf/' + claim.recent_comparison_schedule.id + '?access_token=' + _vm.getToken,
        "target": "_blank"
      }
    }, [_c('li', [_c('strong', [_vm._v(_vm._s(claim.recent_comparison_schedule.name))]), _c('br'), _vm._v("\n                                        —\n                                        " + _vm._s(_vm.dateFormat(claim.recent_comparison_schedule.created_at, "DD/MM/YYYY H:m")) + "\n                                    ")])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.showClaimInfo) ? _c('td', {
      staticClass: "u-padding-30",
      attrs: {
        "colspan": _vm.showColumns.length + 2
      }
    }, [_c('claim-info', {
      attrs: {
        "claim": claim
      },
      on: {
        "close": _vm.updateEditing,
        "save": _vm.saveClaimChanges
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.showReservesCosts) ? _c('td', {
      staticClass: "u-padding-30",
      attrs: {
        "colspan": _vm.showColumns.length + 2
      }
    }, [_c('initial-reserves-costs', {
      attrs: {
        "claim": claim
      },
      on: {
        "close": _vm.updateEditing,
        "save": _vm.saveReserveChanges
      }
    })], 1) : _vm._e()]), _vm._v(" "), (_vm.claims.length === 0) ? _c('tr', [_c('td', {
      staticClass: "u-text-center",
      attrs: {
        "colspan": "showColumns.length + 2"
      }
    }, [_vm._v("\n                    No claims for your current search\n                ")])]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (!_vm.claims.length) ? _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.showColumns.length + 2
    }
  }, [_vm._v("\n                    You do not have any claims saved at present. Click the \"create a new claim\" button above.\n                ")])])]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (!_vm.loading) ? _c('ul', {
    staticClass: "m-pagination"
  }, _vm._l((_vm.pageNumbers), function(page) {
    return _c('li', {
      staticClass: "m-pagination__item",
      class: [page == _vm.isActive ? 'm-pagination__item--active' : '']
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changePage(page)
        }
      }
    }, [_vm._v("\n                " + _vm._s(page) + "\n            ")])])
  }), 0) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-d-flex"
  }, [_c('p', {
    staticClass: "u-r-margin-top-0"
  }, [_vm._v("Control all of your claims here. Perform searches, filters and quick edits.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid__g-8 u-flex-grow-none"
  }, [_c('h2', [_vm._v("No claims for your current search")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid__g-8 u-flex-grow-none"
  }, [_c('p', [_vm._v("\n                Your claims are listed here, use the plus icon on the right of each claim to expand the details for\n                that claim. You can filter the table columns as well to increase or decrease information to suited\n                to your needs.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('strong', [_vm._v("Generate Executive Summary")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21dc68b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claims-dashboard/components/Table.vue
// module id = 1606
// module chunks = 0